const session = {
  namespaced: true,
  state: {
    user: {},
    login: true,
  },
  mutations: {
    updateUser: function(state, user) {
      state.user = user;
    },
    login: function(state) {
      state.login = true;
    },
    logout: function(state) {
      state.login = false;
    },
  }
}
export default session
